// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__WZ55y","unreadBadge":"styles_unreadBadge__2ib_X","modalContent":"styles_modalContent__1WPzB","modal":"styles_modal__3sgbF"};